import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentPropsService {
  constructor() {}

  get isAnflex(): boolean {
    return environment.anflexWeb;
  }

  get isDatasheet(): boolean {
    return environment.datasheet;
  }
}
